/*
 * Copyright (c) 2024 Via Transportation, Inc. All rights reserved.
 *
 * This software is distributed under license and may not be used, copied,
 * modified, or distributed without the express written permission of
 * Via Transportation, Inc.
 */

import {
    ViaDialog,
    ViaButton,
    ViaSmartphoneIcon,
    ViaCallIcon,
    ViaRefreshIcon,
} from "via-react-design-system";
import { FormattedMessage, useIntl } from "react-intl";

import { messages } from "../../messages";
import { useClasses } from "./styles";

interface ProblemsReceiveCodeDialogProps {
    onClose: () => void;
    onResend: () => void;
    onGetPhoneCall: () => void;
    onChangePhoneNumber: () => void;
}

export const ProblemsReceiveCodeDialog = ({
    onClose,
    onResend,
    onGetPhoneCall,
    onChangePhoneNumber,
}: ProblemsReceiveCodeDialogProps) => {
    const classes = useClasses();
    const intl = useIntl();
    return (
        <ViaDialog
            title={intl.formatMessage(messages.problemReceivingCode)}
            open
            onClose={onClose}
            width={424}
        >
            <div className={classes.content}>
                <ViaButton
                    color="secondary"
                    startIcon={<ViaRefreshIcon />}
                    width="fullWidth"
                    variant="ghost"
                    onClick={onResend}
                >
                    <FormattedMessage defaultMessage="Resend code" id="application.login.resend" />
                </ViaButton>
                <ViaButton
                    color="secondary"
                    startIcon={<ViaCallIcon />}
                    width="fullWidth"
                    variant="ghost"
                    onClick={onGetPhoneCall}
                >
                    <FormattedMessage
                        defaultMessage="Get code by phone call"
                        id="application.login.getCodeByPhoneCall"
                    />
                </ViaButton>
                <ViaButton
                    color="secondary"
                    startIcon={<ViaSmartphoneIcon />}
                    width="fullWidth"
                    variant="ghost"
                    onClick={onChangePhoneNumber}
                >
                    <FormattedMessage
                        defaultMessage="Change phone number"
                        id="application.login.changePhoneNumber"
                    />
                </ViaButton>
            </div>
        </ViaDialog>
    );
};
